import { lazy, Suspense, useEffect, useState } from "react";
import { useArtifacts } from "@/contexts/ArtifactsContext";

// Le panneau embarque l'éditeur riche (TipTap) : on ne le charge qu'à la
// première ouverture, puis il reste monté pour conserver son état.
const ArtifactsPanel = lazy(() => import("@/components/chat/ArtifactsPanel"));

export default function ArtifactsHost() {
  const { isOpen } = useArtifacts();
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    if (isOpen) setMounted(true);
  }, [isOpen]);

  if (!mounted && !isOpen) return null;
  return (
    <Suspense fallback={null}>
      <ArtifactsPanel />
    </Suspense>
  );
}
